/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, FormControl, FormLabel, Select, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaBullhorn, FaTrash, FaUserPlus } from 'react-icons/fa'
import { FindUser } from '../../../../../components/FindBox'
import { iConvite, iDemografia, iNomeId } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { ModalBase } from '../../../../../components/ModalBase'
import { ModalComunicao } from '../ModalComunicacao'
import { TableConvites } from '../Table'
import { ActionButton } from '../../../../Jornada/PesquisaInterna/Convites/Components/ModalConviteUsuario/styles'
import { SelectCmp } from '../../../../../components/SelectCmp'
import { ButtonCmp } from '../../../../../components/ButtonCmp'

interface iModalProps {
  isOpen: boolean
  rows: iConvite[]
  imersaoId: string
  Reload: () => void
  onClose: () => void
}

export const ModalConvitePorApp: React.FC<iModalProps> = ({ isOpen, rows, imersaoId, onClose, Reload }) => {
  const toast = useToast()
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [Departamentos, setDepartamentos] = useState<iDemografia[]>([])
  const [ColaboradorId, setColaboradorId] = useState('')
  const [DepartamentoId, setDepartamentoId] = useState('')

  const [Selecionados, setSelecionados] = useState<string[]>([])
  const [ModalComunicacaoIsOpen, setModalComunicacaoIsOpen] = useState(false)

  function getColaboradores(): void {
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => setDepartamentos(res.data))
      .catch(err => console.log(err))
  }

  function ConvidarPorColabId(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Colaborador?colaboradorId=${ColaboradorId}`)
      .then(() => {
        SelecionarUsuario('')
        Reload()
        toast({
          title: 'Colaborador selecionado com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function ConviteByDepartamentoId(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Departamento?departamentoId=${DepartamentoId}`)
      .then(() => {
        Reload()
        setDepartamentoId('')
        toast({
          title: 'Área adicionada com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function ConvidarTodosColaboradores(): void {
    appApi.post(`ImersaoExternaConvite/${imersaoId}/Todos`)
      .then(() => {
        Reload()
        toast({
          title: 'Colaboradores foram adicionados com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
      .catch(err => console.log(err))
  }

  function onCheck(id: string, ids?: string[]): void {
    if (ids) {
      const copy = [...Selecionados]
      if (Selecionados.length === ids.length) {
        setSelecionados([])
      } else {
        for (let i = 0; i < ids.length; i++) {
          if (copy.find(e => e === ids[i]) === undefined) {
            copy.push(ids[i])
          }
        }
        setSelecionados(copy)
      }
    } else {
      const copy = [...Selecionados]
      if (copy.find(e => e === id) === undefined) {
        copy.push(id)
        setSelecionados(copy)
      } else {
        setSelecionados([])
        const filtrado = copy.filter(e => e !== id)
        setSelecionados(filtrado)
      }
    }
  }

  function onDeleteConvites(): void {
    appApi.post('ImersaoExternaConvite/DeletarVarios', Selecionados)
      .then(() => {
        Reload()
        setSelecionados([])
      })
      .catch(err => console.log(err))
  }

  function SelecionarUsuario(id: string): void {
    setColaboradorId(id)
  }

  useEffect(() => {
    getColaboradores()
    getDepartamentos()
  }, [])

  return (
    <ModalBase
      Titulo="Convite por usuário"
      Subtitulo="Utilize os filtros para selecionar apenas os convites que desejar. Você pode filtrar por área ou nome, selecionando os convites que desejar. Poderá também clicar na barra de seleção e adicionar todos os convites que estão aparecendo na lista a partir dos filtros realizados."
      isOpen={isOpen}
      onClose={onClose}
      Width='52rem'
    >
      <ModalComunicao
        isOpen={ModalComunicacaoIsOpen}
        imersaoId={imersaoId}
        onClose={() => setModalComunicacaoIsOpen(false)}
      />
      <Flex p={'0 1rem 1rem 1rem'} flexDir={'column'} gap={'.75rem'}>
        <Flex width={'100%'} gap={'.5rem'} alignItems={'end'}>
          <FormControl>
            <SelectCmp title='Convite por área' value={DepartamentoId} OnChange={setDepartamentoId}>
              <option value={''}>Nenhum</option>
              {
                Departamentos.map((e, i) => {
                  return (
                    <option value={e.id} key={i}>{e.nome}</option>
                  )
                })
              }
            </SelectCmp>
          </FormControl>
          <ButtonCmp w={'10rem'} onClick={ConviteByDepartamentoId} VarColor='Green2'>Selecionar usuários</ButtonCmp>
        </Flex>
        <Flex width={'100%'} gap={'.5rem'} alignItems={'end'}>
          <FormControl alignItems={'start'}>
            <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'}>Pesquisar usuário</FormLabel>
            <FindUser placeholder='Digite um nome' lista={Colaboradores} onChoice={SelecionarUsuario} />
          </FormControl>
          <ButtonCmp w={'10rem'} VarColor='Green2' onClick={ConvidarPorColabId}>Selecionar usuário</ButtonCmp>
        </Flex>
        <Flex margin={'.25rem 0rem'} justifyContent={'center'} gap={'1.5rem'}>
          <ActionButton theme={'var(--Rosa)'} onClick={() => setModalComunicacaoIsOpen(true)}>
            <FaBullhorn size={22} />
            <Flex flexDir={'column'}>
              <span>Adicionar comunicação</span>
              <small>Você pode adicionar textos, imagens e vídeos</small>
            </Flex>
          </ActionButton>
          <ActionButton onClick={ConvidarTodosColaboradores} theme={'var(--Azul)'}>
            <FaUserPlus size={22} />
            <Flex flexDir={'column'}>
              <span>Selecionar todos os colaboradores cadastrados</span>
            </Flex>
          </ActionButton>
        </Flex>

        {
          (rows !== undefined && rows.filter(e => e.status !== 'Respondido').length > 0) && (
            <>
              <Flex fontWeight={'400'} justifyContent={'space-between'} alignItems={'center'}>
                <Text fontSize={'.875rem'} fontWeight={'700'}>Usuários de aplicativos selecionados</Text>
                <ButtonCmp leftIcon={<FaTrash />} VarColor={'Red'} onClick={onDeleteConvites}>Excluir convites selecionados</ButtonCmp>
              </Flex>
              <TableConvites
                isEdit
                rows={rows.filter(e => e.status !== 'Respondido')}
                onCheck={onCheck}
                selecionados={Selecionados}
                onSend={() => { }}
              />
            </>
          )
        }
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'}>
        <ButtonCmp VarColor='Green2' onClick={onClose}>Continuar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
